// extracted by mini-css-extract-plugin
export default {"wrapper":"dzlo6o","deliveryTextShimmer":"_97Rj0","annotation":"Q1hfll","annotationIcon":"vqq889"};